import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

// バージョン情報をpackage.jsonから取得
const APP_VERSION = process.env.REACT_APP_VERSION || require('../../../package.json').version;

const VersionInfo: React.FC = () => (
  <Flex justify="center" py={4}>
    <Text fontSize="xs" color="gray.500">
      Version {APP_VERSION}
    </Text>
  </Flex>
);

export default VersionInfo;
